<template>
  <the-content v-model="showFilters">

    <template v-slot:content>
      <div class="mh2-l mv2">
        <search :placeholder="searchPlaceholder" @search="runSearch" @reset="resetSearch" class="mb2"/>

        <request v-if="search" :method="search.method" :params="search.params" #default="{ loading, error }" v-model="found">
          <content-spinner v-if="loading" class="mv3"/>
          <div v-else-if="error" class="mv3">Ошибка: {{ error }}</div>
          <list-item v-else-if="foundProcedure" :proc="foundProcedure"></list-item>
          <div v-else class="text-secondary mv3">процедура не найдена</div>
        </request>
        <div v-else>
          <div class="list-grid">
            <list-item v-for="(proc, index) in filteredProcedures" :key="index" :proc="proc"></list-item>
          </div>
          <div class="mv3 flex justify-center" v-if="totalCount">
            <paginator :page="page" :total="totalCount" resource="procedures" />
          </div>
        </div>
      </div>
    </template>

    <template v-slot:sidebar>
      <filters class=""></filters>
    </template>

    <template v-slot:mobile-sidebar>
      <filters></filters>
    </template>

  </the-content>
</template>

<script>
import TheContent from '@/components/Content.vue'
import Search from '@/components/common/Search.vue'
import Request from '@/components/Request.vue'
import ContentSpinner from '@/components/common/ContentSpinner.vue'
import Filters from '@/components/procedures/Filters.vue'
import ListItem from '@/components/procedures/ListItem.vue'
import Paginator from '@/components/Paginator.vue'
import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  components: {
    TheContent,
    Search,
    Request,
    ContentSpinner,
    Filters,
    ListItem,
    Paginator
  },
  props: { page: { default: 1 } },
  watch: {
    page: {
      immediate: true,
      handler: (p) => {
        store.dispatch('procedure/load', p)
      }
    }
  },
  data () {
    return {
      showFilters: false,
      searchPlaceholder: 'поиск по номеру процедуры',
      search: null,
      found: null
    }
  },
  computed: {
    ...mapGetters('procedure', ['filteredProcedures', 'makeProcedure', 'totalCount']),
    ...mapGetters('user', ['user']),
    foundProcedure () {
      if (this.found.procedures) {
        const [procedure] = this.makeProcedure(this.found)
        return procedure
      } else {
        return null
      }
    }
  },
  methods: {
    runSearch (input) {
      if (input) {
        const id = parseInt(input)
        this.search = {
          method: 'getProcedures',
          params: {
            companyId: this.user.companyId,
            procedureId: Number.isInteger(id) ? id : null
          }
        }
      } else {
        this.resetSearch()
      }
    },
    resetSearch () {
      this.search = null
      this.found = null
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
